import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Table, Button, Typography, Space, Card, message, Spin, Modal } from 'antd';

const { Text, Title } = Typography;
const { confirm } = Modal;

const PreinscritsList = () => {
  const [preinscrits, setPreinscrits] = useState([]);
  const [loading, setLoading] = useState(false);
  const [validatingId, setValidatingId] = useState(null);

  const token = localStorage.getItem('token');
  const employerStr = localStorage.getItem('employer');

  // Récupérer le rôle et l'id une fois pour tout le composant
  const currentUser = employerStr ? JSON.parse(employerStr) : null;
  const isAdmin = currentUser?.roles?.some(r => r.nomrole === 'ROLE_ADMIN');
  const isInfluenceur = currentUser?.roles?.some(r => r.nomrole === 'ROLE_INFLUENCEUR');
  const currentInfluenceurId = currentUser?.id;

  useEffect(() => {
    fetchPreinscrits();
  }, []);

  const fetchPreinscrits = () => {
    setLoading(true);

    axios.get('http://localhost:8080/admin/api/getPreinscris', {
      headers: {
        'Authorization': 'Basic ' + token,
        'Content-Type': 'application/json',
      },
    })
      .then(res => {
        const allData = res.data.filter(p => !p.inscriptionValider);

        let filteredData = [];

        if (isAdmin) {
          filteredData = allData;
        } else if (isInfluenceur) {
          filteredData = allData.filter(p =>
            p.influenceur?.userSystem?.id === currentInfluenceurId
          );
        }

        setPreinscrits(filteredData);
      })
      .catch(err => {
        console.error(err);
        message.error('Erreur lors de la récupération des préinscrits');
      })
      .finally(() => setLoading(false));
  };

  const handleValider = (id, nom, prenom) => {
    confirm({
      title: 'Confirmation',
      content: `Voulez-vous vraiment valider la préinscription de ${nom} ${prenom} ?`,
      okText: 'Oui',
      okType: 'primary',
      cancelText: 'Non',
      onOk() {
        setValidatingId(id);

        return axios.post(`http://localhost:8080/admin/api/valider-preinscription/${id}`, {}, {
          headers: {
            'Authorization': 'Basic ' + token,
            'Content-Type': 'application/json',
          },
        })
          .then(res => {
            message.success(res.data || 'Préinscription validée');
            setPreinscrits(prev => prev.filter(p => p.id !== id));
          })
          .catch(err => {
            message.error('Erreur lors de la validation');
          })
          .finally(() => setValidatingId(null));
      },
      onCancel() {},
    });
  };

  // Colonnes de base communes
  const baseColumns = [
    {
      title: 'Nom',
      dataIndex: ['userSystem', 'nom'],
      key: 'nom',
      sorter: (a, b) => a.userSystem.nom.localeCompare(b.userSystem.nom),
      render: text => <Text strong>{text}</Text>,
    },
    {
      title: 'Prénom',
      dataIndex: ['userSystem', 'prenom'],
      key: 'prenom',
      sorter: (a, b) => a.userSystem.prenom.localeCompare(b.userSystem.prenom),
    },
    {
      title: 'Téléphone',
      dataIndex: ['userSystem', 'telephone'],
      key: 'telephone',
    },
    {
      title: 'Email',
      dataIndex: ['userSystem', 'email'],
      key: 'email',
      render: email => <a href={`mailto:${email}`}>{email}</a>,
    },
  ];

  // Colonnes visibles uniquement par ADMIN
  const adminOnlyColumns = [
    {
      title: 'Influenceur',
      key: 'influenceur',
      render: (_, record) => {
        const infUser = record.influenceur?.userSystem || {};
        return (
          <Space direction="vertical" size={0}>
            <Text strong>{infUser.nom}</Text>
            <Text type="secondary">{infUser.email}</Text>
            <Text type="secondary">{infUser.telephone}</Text>
          </Space>
        );
      },
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Button
          type="primary"
          loading={validatingId === record.id}
          onClick={() =>
            handleValider(record.id, record.userSystem.nom, record.userSystem.prenom)
          }
        >
          Valider
        </Button>
      ),
    },
  ];

  // Selon le rôle on concatène les colonnes à afficher
  const columns = isAdmin ? [...baseColumns, ...adminOnlyColumns] : baseColumns;

  return (
    <Card
      title={<Title level={3} style={{ color: '#1890ff' }}>Liste des Préinscrits</Title>}
      style={{ maxWidth: 1000, margin: '2rem auto', boxShadow: '0 8px 16px rgba(0,0,0,0.1)' }}
    >
      {loading ? (
        <Space style={{ width: '100%', justifyContent: 'center', padding: '2rem' }}>
          <Spin size="large" tip="Chargement..." />
        </Space>
      ) : (
        <Table
          columns={columns}
          dataSource={preinscrits}
          rowKey={record => record.id}
          pagination={{ pageSize: 8 }}
          bordered
          scroll={{ x: 900 }}
          style={{ backgroundColor: '#fafafa' }}
        />
      )}
    </Card>
  );
};

export default PreinscritsList;
